import { DROMO_DATE_FORMAT } from "integrations/dromo/dromoFormats";
import { PAID_TO_AGENCY_LOGGED_PAYMENT_METHOD_OPTIONS } from "common/constants";

export default [
  {
    key: "client_reference_id",
    label: "Client Reference ID",
    type: "string",
    validators: [{ validate: "require_without_all", fields: ["external_id"] }],
    description:
      "The Client Reference ID for the account. Should be provided only if no external id is provided.",
  },
  {
    key: "external_id",
    label: "External Account ID",
    type: "string",
    validators: [{ validate: "require_without_all", fields: ["client_reference_id"] }],
    description:
      "The External ID for the account. Should be provided only if no client reference id is provided.",
  },
  {
    key: "creditor_id",
    label: "Client ID",
    type: "number",
  },
  {
    key: "transaction_date",
    label: "Transaction Date",
    type: DROMO_DATE_FORMAT,
    validators: [{ validate: "required" }],
  },
  {
    key: "transaction_amount",
    label: "Transaction Amount",
    type: ["number", "usd"],
    validators: [{ validate: "required" }],
  },
  {
    key: "notes",
    label: "Notes",
    type: "string",
    description: "Notes for the payment",
  },
  {
    key: "payment_method_type",
    label: "Payment Method",
    type: "select",
    selectOptions: PAID_TO_AGENCY_LOGGED_PAYMENT_METHOD_OPTIONS,
    description:
      "Payment method (defaults to 'Other' for agency payments, 'Paid to Creditor' for creditor payments)",
  },
];
